// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:768px){.default-confirm[data-v-69088453]{min-height:60px}.default-confirm .default-confirm-title[data-v-69088453]{margin-bottom:24px;font-size:32px;line-height:44px}.default-confirm .default-confirm-description[data-v-69088453]{max-height:60vh;font-size:28px;line-height:44px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
